import { DesignContextProvider } from "Components/DesignContext";
import React from "react";
import { render } from "react-dom";
import Banner from ".";

export function initBanner(model: Readonly<LSCommon.Service.LSWebUI.Models.XPP.WorkspaceLandingPageJsViewModel>, onBook: (date?: Date) => void) {
   const container = document.getElementById("wlp-top-banner");

   if (!container) {
      return;
   }

   if (!model.ShareReservation) {
      return;
   }

   render(<DesignContextProvider name="primary">
      <Banner shareReservation={model.ShareReservation} onBook={onBook}/>
   </DesignContextProvider>
      , container);
}